import PayoutProfiles from 'modules/Referral/PayoutProfiles/List/PayoutProfiles'
import Reducer from 'modules/Referral/PayoutProfiles/List/reducer'

export default PayoutProfiles

export { Reducer }
